export const COMPANYTAXOVERVIEWLIST_YEAR = 'COMPANYTAXOVERVIEWLIST_YEAR';
export const COMPANYTAXOVERVIEWLIST_TAXTYPEID = 'COMPANYTAXOVERVIEWLIST_TAXTYPEID';
export const COMPANYTAXOVERVIEWLIST_PERIODID = 'COMPANYTAXOVERVIEWLIST_PERIODID';